import { createStyles, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      borderBottom: 'solid 0.125rem #CC0000',
      position: 'relative',
      padding: '1.25rem',
      textAlign: 'center',
      lineHeight: 'initial'
    },
    arrow: {
      verticalAlign: 'middle',
      height: '100%',
      position: 'absolute',
      fontSize: '0.8125rem',
      top: '0',
      left: '2rem'
    },
    shareVariation: {
      display: 'flex',
      justifyContent: 'center'
    },
    sharePrice: {
      margin: '0 0.5rem'
    }
  })
)
